import {
    getCommercialAllListRequest,
    getCommercialAllRequest,
    getCommercialNoAccountListRequest,
    getCommercialNoAccountRequest,
} from '../../../../services/network/sell/all/commercial';

class CommonCommercialAllService {
    async getCommercialAll(id) {
        return await getCommercialAllRequest(id);
    }

    async getCommercialAllList(payload) {
        return await getCommercialAllListRequest(payload);
    }

    async getCommercialNoAccount(id) {
        return await getCommercialNoAccountRequest(id);
    }

    async getCommercialNoAccountList(payload) {
        return await getCommercialNoAccountListRequest(payload);
    }
}

export const CommercialAllService = new CommonCommercialAllService();
